export default __webpack_public_path__ + "s12.png";